export default "__VITE_ASSET__C58EkU09__"